import { Permission } from "@/store/modules/user";
import { RootState } from "@/store/types";
import { GetterTree } from "vuex";
import { PreferenceKeys, ProfileState } from "./types";

export const getters: GetterTree<ProfileState, RootState> = {
  fullName(state): string {
    return state.data.name;
  },
  userID(state): string {
    return state.data.userID;
  },
  email(state): string {
    return state.data.email;
  },
  sessionStart(state): string {
    return state.data.sessionStart;
  },
  ipAddr(state): string {
    return state.data.ip;
  },
  computer(state): string {
    return state.data.computer;
  },
  pagerID(state): string {
    return state.data.pagerID;
  },
  areas(state): Array<string> {
    if (state.data) {
      return state.data.areas;
    } else {
      return [];
    }
  },
  system(state): Record<string, any> {
    return state.system;
  },
  systemLoaded(state): boolean {
    return state.systemLoaded;
  },
  isMask(state): boolean {
    return state.data.mask === true;
  },
  isPermanentMask(state): boolean {
    return state.data.permanentMask === true;
  },
  canEdit(state): boolean {
    return state.data.canEdit;
  },
  isAdmin(state): boolean {
    return state.data.isAdmin === true;
  },
  isLoggedIn(state): boolean {
    return state.data.status === 1;
  },
  user(state) {
    return state.data;
  },
  demo(state) {
    return state.system && state.system.demo;
  },
  area(state): string {
    return state.area;
  },
  audioAlertsEnabled(state): boolean {
    return state.audioAlertsEnabled;
  },
  alertRepeatInterval(state): number {
    return state.alertRepeatInterval;
  },
  speechSynthesisEnabled(state): boolean {
    return state.speechSynthesisEnabled;
  },
  supportsSpeechSynthesis() {
    return typeof SpeechSynthesisUtterance !== "undefined";
  },
  isWirelessTesting(state) {
    return state.data.isTesting;
  },
  preferences(state) {
    return state.preferences;
  },
  preferenceTemperature(state) {
    if (state.preferences[PreferenceKeys.TEMPERATURE]) {
      return state.preferences[PreferenceKeys.TEMPERATURE];
    } else {
      return "C";
    }
  },
  hasShownLoginMs(state) {
    return state.hasShownLoginMs;
  },
  showGreenGrayOnly(state) {
    // Avoid showing red/yellow levels to patients
    return state.data.rights.includes(Permission.PATIENT);
  }
};
